 
import React from 'react';
import queryString from 'query-string';
import {withRouter} from 'react-router-dom';
import * as yup from 'yup';
import Moment from 'moment';
import {agentDeveloperUtils, countries} from 'wobi-web-common';
import {Formik, Form} from 'formik';
import {Persist, FORMIK_DEBOUNCE} from '../utils/formik-persist';
import TabsLayout from '../components/TabsLayout';
import {Tab1, Tab2, Tab3, Tab4, Tab3_Extended} from './tabs-contents/initial-details';
import stepsTabs from '../config/tabs';
import {getCurrentTabIndex, tabIndexToName} from '../utils/routingHelpers';
import {tab3InitialData} from './tabs-contents/initial-details/helpers/Tab3_helpers/tab3InitialData';
import {tab3ExtendedInitialData} from './tabs-contents/initial-details/helpers/Tab3_Extended_helpers/tab3ExtendedInitialData';
import {getTravelers} from './tabs-contents/initial-details/helpers/Tab3_helpers/utils';
import {getStartingDate, getTravelInitialDetails} from '../utils/apiHandlers';
import {stripNullValues} from '../utils/stripNullValues';
import {scrollToFirstError} from '../utils/scrollToFirstError';
import {preSaveHandler, setUtmFields, getOffersFields, setOffersFields} from '../utils/persistOfferDetails';
import {Button} from '@mui/material';
import {
  constractCampaignArgs,
  fireGtmEvent,
  consumeResultsVisited,
} from '../utils/marketing.utils';
import OtpContainer from '../components/OtpContainer';

import PropTypes from 'prop-types';

const queryStringParametersNames = [
  'first-referrer',
  'gclid',
  'referrer',
  'utm_source',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'utm_medium',
  'first-utm_medium',
  'first-utm_source',
  'first-gclid',
  'utm_keywords',
];

let validate = () => {};
let touch = () => {};

// Block for setting formik initialValues
const tab2TravelerData = {phone1: ''};
for (let i = 1; i <= 10; i++) {
  tab2TravelerData['dob' + i] = null;
  tab2TravelerData['ID' + i] = '';
  tab2TravelerData['firstName' + i] = '';
  tab2TravelerData['lastName' + i] = '';
  tab2TravelerData['gender' + i] = '';
}
const formikInitialValues = {
  policyStartDate: null,
  policyEndDate: null,
  targetFrame: [],
  targetCountries: [], // tab1 fields
  targetCountriesHebrew: [], // tab1 fields
  policyholdNum: 1,
  isLeftIsrael: false,
  ...tab2TravelerData, // tab2 fields
  ...tab3InitialData, // tab3 fields
  ...tab3ExtendedInitialData, // tab3 extended fields
  isDetection: true,
  isLiable: true, // tab4 fields
  isCharger: false,
  isEsports: false,
  isWsports: false,
  isTravelc: false,
  isTravelsc: false,
  isPccover: false,
  isMobilecover: false,
  startDateExtremeSport: null,
  endDateExtremeSport: null,
  startDateWinterSport: null,
  endDateWinterSport: null,
  isCancellationOfSelfParticipationOnRentedCar: false,
  isTerms: false, // tab5 fields
  isOwnerHospital: false,
  isOwnerHospital2: '',
  pccoverManufacturer: '',
  pccoverModel: '',
  pccoverYear: '',
  mobilecoverManufacturer: '',
  mobilecoverModel: '', // tab5 fields
};

const defaultTraveler = {
  ID: '',
  dob: null,
  firstName: '',
  lastName: '',
  gender: '',
};

class InitialDetailsPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.getStartDate = this.getStartDate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.runValidation = this.runValidation.bind(this);
    this.handleCurrentTabValidation = this.handleCurrentTabValidation.bind(this);
    this.setTab = this.setTab.bind(this);
    this.refSubmit = React.createRef();
    this.handleAdditionalDiseaseChange = this.handleAdditionalDiseaseChange.bind(this);
    this.handleOtpVerified = this.handleOtpVerified.bind(this);
  }

  state = {
    isOtpFirst: false,
    otpOpen: false,
    isRestoringLead: false,
    tab: 0,
    startDateStatus: 'loading',
    validationFields: {},
    tabs: stepsTabs().details.filter((tab) => tab.key !== 'medical_extended'),
    showMedicalExtendedModal: false,
    showExtendedModalVisible: false,
  };

  fixQueryStringDuplicateParam(querystringParameters) {
    const fixedQueryStringParameters = {
      ...querystringParameters,
    };
    const stringParameters = Object.keys(fixedQueryStringParameters);
    stringParameters.forEach(parameter => {
      if (queryStringParametersNames.includes(parameter)) {
        if (Array.isArray(fixedQueryStringParameters[parameter])) {
          fixedQueryStringParameters[parameter] = fixedQueryStringParameters[parameter][0];
        }
      }
    });
    return fixedQueryStringParameters;
  }

  setCampaignArgs() {
    const {location} = this.props;
    const values = queryString.parse(location.search || location.hash.split('?')[1]);
    const fixedValues = this.fixQueryStringDuplicateParam(values);
    const offersFields = constractCampaignArgs(fixedValues);
    if (fixedValues['first-referrer']) {
      offersFields.first_referrer = fixedValues['first-referrer'];
    }
    if (fixedValues['first-utm_medium']) {
      offersFields.first_utm_medium = fixedValues['first-utm_medium'];
    }
    if (fixedValues['first-utm_source']) {
      offersFields.first_utm_source = fixedValues['first-utm_source'];
    }
    if (fixedValues['first-gclid']) {
      offersFields.first_gclid = fixedValues['first-gclid'];
    }
    setUtmFields(offersFields);
  }

  componentDidMount() {
    if (agentDeveloperUtils.isOtpFirstInOffersFields()) {
      this.handleOtpFirstOnMount();
    }
    this.setCampaignArgs();
    this.getStartDate();
    this.props.changeSideBar(true);
    this.unblock = this.props.history.block((location, action, callback) => {
      const tabIndex = getCurrentTabIndex(location, 'details');
      const {pathname} = location;
      if (!pathname.includes('offers') && this.state.tab >= tabIndex) {
        return true;
      }

      // Allow the transition to pass or block it asynchronously
      // When the handler returns `undefined` the transitions will be blocked until the callback
      // is called with either `true` to allow navigation or `false` to block it.
      this.runValidation().then((res) => callback(res));
    });
    const parameters = queryString.parse(this.props.location.search || this.props.location.hash.split('?')[1]);
    if (parameters.pid) {
      const parentLeadId = parameters.pid;
      sessionStorage.setItem('parentLeadId', parentLeadId);
    }
    if (this.state.tab === 0 && parameters && parameters.referrer) {
      fireGtmEvent('TravelStart', {
        referrer: parameters.referrer,
      });
    }
  }

  async runValidation() {
    const errors = await validate();
    if (Object.keys(errors).length !== 0) {
      Object.keys(this.state.validationFields).forEach((field) => touch(field, true));
      scrollToFirstError(errors);
      return false;
    }
    return true;
  }

  UNSAFE_componentWillMount() {
    const otpMethods = agentDeveloperUtils.getOtpMethods;
    this.setState({otpMethods});
    this.setTab(this.props.location);
    this.unlisten = this.props.history.listen((location) => {
      this.setTab(location);
    });

    window.addEventListener('keypress', this.enterSubmitForm);
  }

  getStartDate() {
    this.setState({initialStartDate: null, startDateStatus: 'loading'});
    getStartingDate().then(resp => {
      const startDate = resp?.data?.startDate;
      if (
        resp?.success &&
        typeof startDate === 'string' &&
        Moment(startDate, 'YYYY-MM-DD', true).isValid()
      ) {
        this.setState({initialStartDate: startDate, startDateStatus: 'ready'});
        return null;
      }
      console.error('Failed to retrieve a valid travel start date', resp);
      this.setState({initialStartDate: null, startDateStatus: 'error'});
      return null;
    }).catch(error => {
      console.error('Failed to retrieve the travel start date', error);
      this.setState({initialStartDate: null, startDateStatus: 'error'});
    });
  }

  handleChange(tabIndex, setFieldValue, values) {
    if (tabIndex === this.state.tab) {
      return;
    }
    if (tabIndex === 5) {
      this.submit();
      return;
    }
    if (tabIndex === 2 && values) {
      const travelers = getTravelers(values);
      setFieldValue('travelers', travelers);
    }

    const tabName = tabIndexToName(tabIndex, this.state.tabs);
    this.props.history.push(`#${tabName}`);
  }

  handleCurrentTabValidation(tabValidation, fromTab, activeTab) {
    if (Object.keys(tabValidation).length !== Object.keys(this.state.validationFields).length &&
      activeTab === fromTab) {
      return new Promise(resolve => {
        this.setState({validationFields: tabValidation}, resolve);
      });
    }

    return Promise.resolve();
  }

  setTab(location) {
    const {hash} = location;
    const tabKey = hash.replace('#', '');
    const returnedFromResults = consumeResultsVisited() && this.props.history.action === 'POP';
    const tabObject = this.state.tabs.find(tab => tabKey === tab.key);
    if (!tabObject) {
      return;
    }
    if (tabObject.key === 'coverage' && returnedFromResults) {
      fireGtmEvent('BackToCoverages');
    }
    this.setState({tab: tabObject.index});
  }

  submit() {
    this.props.history.push('offers');
  }

  enterSubmitForm = (e) => {
    const submitButton = this.refSubmit.current;
    if (e.keyCode === 13 && submitButton?.form?.contains(e.target)) {
      submitButton.click();
    }
  }

  componentWillUnmount() {
    this.unlisten();
    window.removeEventListener('keypress', this.enterSubmitForm);
  }

  updateFormikValidateForm = (formikValidateForm, formikSetTouched) => {
    validate = formikValidateForm;
    touch = formikSetTouched;
  }

  handleOtpVerified() {
    if (this.state.isOtpFirst) {
      this.handleOtpFirstOnOtpVerified();
    } else {
      this.props.history.push('/offers');
    }
  }

  handleOtpBlocked() {
    this.props.history.push('/overuse');
  }

  handleOtpOpen = () => {
    if (
      getOffersFields('phone') &&
      getOffersFields('token') &&
      getOffersFields('offersCallId')
    ) {
      this.handleOtpVerified();
    } else {
      this.setState({otpOpen: true,
        isOtpFirst: true});
    }
  };

  handleManualOtpOpen = (values) => {
    fireGtmEvent('ExcistingCustomer');
    const {
      policyStartDate, policyEndDate, targetFrame, targetCountries, targetCountriesHebrew,
    } = values;
    this.otpRecoveryContext = {
      token: null,
      tripValues: {policyStartDate, policyEndDate, targetFrame, targetCountries, targetCountriesHebrew},
    };
    this.setState({otpOpen: true, isOtpFirst: true});
  };

  handleAdditionalDiseaseChange(event) {
    const showExtended = event !== false;
    sessionStorage.setItem('travel.details-form.isShowMedicalExtended', showExtended);
    this.setState({tabs: stepsTabs(showExtended).details});
  }

  handleOtpFirstOnMount() {
    this.otpRecoveryContext = {token: getOffersFields('token')};
    this.setState({isOtpFirst: true}, this.handleOtpOpen);
    setOffersFields({otp: ''});
  }

  handleOtpFirstOnOtpVerified() {
    const recoveryContext = this.otpRecoveryContext;
    const agentDeveloperName = agentDeveloperUtils.getAgentDeveloperName === 'Wobi' ? '' : agentDeveloperUtils.getAgentDeveloperName;
    const requestData = {
      agentDeveloperName,
      otpToken: getOffersFields('otpToken'),
      token: recoveryContext ? recoveryContext.token : getOffersFields('token'),
    };

    getTravelInitialDetails(requestData).then(resp => {
      if (!resp.success || !resp.data) {
        console.error('Failed to fetch lead data - invalid response', resp);
        return null;
      }
      const initialDetailsValues = stripNullValues(resp.data);
      // Fill targetCountriesHebrew from English names for old leads that don't have Hebrew stored
      if ((!initialDetailsValues.targetCountriesHebrew || initialDetailsValues.targetCountriesHebrew.length === 0)
        && initialDetailsValues.targetCountries?.length > 0) {
        initialDetailsValues.targetCountriesHebrew = initialDetailsValues.targetCountries.map(englishName => {
          const found = countries.find(c => c.value === englishName);
          return found ? found.label : englishName;
        });
      }
      const restoredTravelers = Array.isArray(initialDetailsValues.travelers) && initialDetailsValues.travelers.length
        ? initialDetailsValues.travelers
        : getTravelers(initialDetailsValues);
      const normalizedInitialDetailsValues = {
        ...initialDetailsValues,
        // Consent was already given in the OTP form, so restored leads must not be sent back to re-accept it
        isTerms: true,
        travelers: restoredTravelers.length ? restoredTravelers : [defaultTraveler],
        ...recoveryContext?.tripValues,
      };
      const detailsForm = JSON.parse(sessionStorage.getItem('travel.details-form')) || {};
      detailsForm.values = normalizedInitialDetailsValues;
      const hasTravelDates = Boolean(
        normalizedInitialDetailsValues.policyStartDate && normalizedInitialDetailsValues.policyEndDate,
      );
      const hasCountries = Array.isArray(normalizedInitialDetailsValues.targetCountries)
        && normalizedInitialDetailsValues.targetCountries.length > 0;
      const showInsured = Boolean(recoveryContext?.tripValues) || hasTravelDates && hasCountries;
      // Unmount Persist first so its pending save cannot overwrite the recovered lead during reload.
      this.setState({isRestoringLead: true}, () => {
        sessionStorage.setItem('otpFirst', true);
        sessionStorage.setItem('travel.details-form', JSON.stringify(detailsForm));
        window.location.hash = showInsured ? '#insured' : '#destination';
        window.location.reload();
      });
      return null;
    }).catch((error) => console.error('Failed to fetch lead data', error));
  }

  render() {
    const activeTab = this.state.tab;
    const showOTP = true;
    return (
      <Formik
        validationSchema={yup.object().shape(this.state.validationFields)}
        initialValues={{...formikInitialValues}}>
        {({values, errors, handleChange, handleSubmit, isSubmitting, setFieldValue, setFieldTouched, validateForm}) => (
          <Form>
            <TabsLayout
              tabs={this.state.tabs}
              currentTabIndex={activeTab}
              handleChange={(event, tabIndex) => {
                this.handleChange(tabIndex);
                fireGtmEvent('MenuTravelDetails', {tabIndex});
              }}
              formikSetTouched={setFieldTouched}
              formikValidateForm={validateForm}
              formikSetField={setFieldValue}
              formikErrors={errors} formikValues={values}
              formikHandleChange={handleChange}
              handleSubmit={handleSubmit}
              formikIsSubmitting={isSubmitting}
              updateFormikValidateForm={this.updateFormikValidateForm}
            >
              <Tab1
                initialStartDateFromServer={this.state.initialStartDate}
                initialStartDateStatus={this.state.startDateStatus}
                onRetryStartDate={this.getStartDate}
                validationCallback={(tabValidation) => this.handleCurrentTabValidation(tabValidation, 0, activeTab)}
                submitCallback={(tabIndex) => this.handleChange(tabIndex)}
                submitButtonRef={this.refSubmit}
              />
              <Tab2
                onButtonClickOTP={() => this.handleManualOtpOpen(values)}
                validationCallback={(tabValidation) => this.handleCurrentTabValidation(tabValidation, 1, activeTab)}
                submitCallback={(tabIndex) => this.handleChange(tabIndex, setFieldValue, values)}
                actionButton={activeTab === 1 ? ({children, ...props}) => (
                  <Button ref={this.refSubmit} {...props}>
                    {' '}
                    {children}
                    {' '}
                  </Button>
                ) : null}
              />
              <Tab3
                validationCallback={(tabValidation) => this.handleCurrentTabValidation(tabValidation, 2, activeTab)}
                submitCallback={(tabIndex) => {
                  if (tabIndex > this.state.tab && this.state.showMedicalExtendedModal) {
                    this.setState({showExtendedModalVisible: true});
                  } else {
                    this.handleChange(tabIndex);
                  }
                }}
                activeTab={activeTab}
                actionButton={activeTab === 2 ? ({children, ...props}) => (
                  <Button ref={this.refSubmit} {...props}>
                    {' '}
                    {children}
                    {' '}
                  </Button>
                ) : null}
                handleAdditionalDiseaseChange={this.handleAdditionalDiseaseChange}
              />
              {this.state.tabs.some(t => t.key === 'medical_extended') && (
                <Tab3_Extended
                  validationCallback={(tabValidation) => this.handleCurrentTabValidation(tabValidation, 3, activeTab)}
                  submitCallback={(tabIndex) => this.handleChange(tabIndex)}
                  onCloseModal={() => this.handleChange(2)}
                  activeTab={activeTab}
                  actionButton={activeTab === 3 ? ({children, ...props}) => (
                    <Button ref={this.refSubmit} {...props}>
                      {' '}
                      {children}
                      {' '}
                    </Button>
                  ) : null}
                />
              )}
              <Tab4
                validationCallback={(tabValidation) => this.handleCurrentTabValidation(tabValidation, 4, activeTab)}
                submitCallback={(tabIndex) => this.handleChange(tabIndex)}
                handleOtpOpen={this.handleOtpOpen}
                actionButton={activeTab === 4 ? ({children, ...props}) => (
                  <Button ref={this.refSubmit} {...props}>
                    {' '}
                    {children}
                    {' '}
                  </Button>
                ) : null}
                showOTP={showOTP}
              />
            </TabsLayout>
            {this.state.showExtendedModalVisible && activeTab === 2 && (
              <Tab3_Extended
                validationCallback={() => {}}
                submitCallback={() => {
                  this.setState({showExtendedModalVisible: false});
                  this.handleChange(3);
                }}
                onCloseModal={() => this.setState({showExtendedModalVisible: false})}
                activeTab={activeTab}
                formikSetField={setFieldValue}
                formikErrors={errors}
                formikValues={values}
                formikSetTouched={setFieldTouched}
                formikValidateForm={validateForm}
                formikIsSubmitting={isSubmitting}
                className={null}
              />
            )}
            <OtpContainer
              open={this.state.otpOpen}
              handleVerified={() => this.handleOtpVerified()}
              handleBlocked={() => this.handleOtpBlocked()}
              handleClose={() => this.setState({otpOpen: false})}
              showNID={false}
              fullname={values?.firstName1 + ' ' + values?.lastName1}
              phone={values?.phone1}
              values={values}
              otpMethods={this.state.otpMethods}
            />
            {!this.state.isRestoringLead && <Persist
              isSessionStorage
              name='travel.details-form'
              preSaveHandler={preSaveHandler}
              debounce={FORMIK_DEBOUNCE}
            />}
          </Form>
        )}
      </Formik>
    );
  }
}

InitialDetailsPage.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  changeSideBar: PropTypes.func.isRequired,
};

export default withRouter(InitialDetailsPage);
